export default class LastBuySellDefinition {
  static getDefault = () =>
    new LastBuySellDefinition({
      lastSell: false,
      lastBuy: false,
    });

  #lastBuy;
  #lastSell;

  constructor(props = {}) {
    const { lastBuy, lastSell } = props;
    this.#lastBuy = lastBuy ?? false;
    this.#lastSell = lastSell ?? false;
  }

  get lastBuy() {
    return this.#lastBuy;
  }

  get lastSell() {
    return this.#lastSell;
  }

  setLastBuy = (value) =>
    new LastBuySellDefinition({ lastBuy: value, lastSell: this.#lastSell });

  setLastSell = (value) =>
    new LastBuySellDefinition({ lastSell: value, lastBuy: this.#lastBuy });

  get complete() {
    return true;
  }

  get key() {
    return [this.#lastBuy, this.#lastSell].join(",");
  }

  copy = () => {
    return {
      lastBuy: this.lastBuy,
      lastSell: this.lastSell,
    };
  };
}
